import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { Router } from '@angular/router';
import { UtilitiesService } from 'src/app/shared/utilities/utilities.service';
import { ApiService } from 'src/app/services/api.service';
import {MatDialog} from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { ViewMessageComponent } from '../shared/view-message/view-message.component';

@Component({
  selector: 'app-view-notifications',
  templateUrl: './view-notifications.component.html',
  styleUrls: ['./view-notifications.component.css']
})
export class ViewNotificationsComponent implements OnInit {
  notifications = [];
  Deletednotifications = [];
  unReadnotifs = [];
  flaggedNotifs = [];
  selection = new SelectionModel<any>(true, []);
  Delselection = new SelectionModel<any>(true, []);
  Unreadselection = new SelectionModel<any>(true , []);
  Flaggedselection = new SelectionModel<any>(true , []);
  notifColoumns = ['select', 'Date', 'Subject', 'Actions'];
  NonDelpage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  Delpage = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  unread = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  flagged = {
    pageSizeOptions: [10, 25, 50, 100]
    , limit: 25
    , pageSize: 25
    , index: 0
  };
  constructor(public router: Router
    , public _util: UtilitiesService
    , public _api: ApiService
    , public dialog: MatDialog
   
    , public spinner: NgxSpinnerService) { }

  ngOnInit() {
 
      this.getNotis();



  }

  gotoBackPage() {
    // this.router.navigate(['../profile']);
    this._util.goToBack();

  }
  getNotis() {
    this.PaginationReset(25, 'NonDelpage');
    this.PaginationReset(25, 'Delpage');
    this.PaginationReset(25, 'unread');
    this.PaginationReset(25, 'flagged');
    this.getNotification({ page: 1, pageSize : 25 , PageType: 'NonDelpage' });
    this.getNotification({ page: 1, pageSize : 25 , filter: 'unread' });
    this.getNotification({ page: 1, pageSize : 25 , filter: 'flagged' });
    this.getNotification({ page: 1, pageSize : 25 , PageType: 'Delpage' });
    this.selection.clear();
    this.Delselection.clear();
    this.Unreadselection.clear();
    this.Flaggedselection.clear();
    this._util.ReadMessage(true);
  }
  PaginationReset(size: number, type) {
    this[type].limit = size;
    this[type].pageSize = size;
    this[type].index = 0;
  }
  PageChange($event, type) {
    this[type].pageSize = $event.pageSize;
    this[type].index = $event.pageIndex;
    const data = {
      page: $event.pageIndex + 1,
      pageSize:  this[type].pageSize,
      PageType : type
    };
    if (type === 'Delpage') {
      data['isDeleted'] = 'Y';
    } else  if (type === 'NonDelpage') {
      data['filter'] = null;
    } else {
    data['filter'] = type;
    }
    this.getNotification(data);
  }
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.notifications.length;
    return numSelected === numRows;
  }
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.notifications.forEach(row => this.selection.select(row));
    this.isAllSelected() ? this.notifications.forEach(row => row.checkbox = true) :
      this.notifications.forEach(row => row.checkbox = false);
  }



  isAllDelSelected() {
    const numSelected = this.Delselection.selected.length;
    const numRows = this.Deletednotifications.length;
    return numSelected === numRows;
  }
  masterDelToggle() {
    this.isAllDelSelected() ?
      this.Delselection.clear() :
      this.Deletednotifications.forEach(row => this.Delselection.select(row));
    this.isAllDelSelected() ? this.Deletednotifications.forEach(row => row.checkbox = true) :
      this.Deletednotifications.forEach(row => row.checkbox = false);
  }
  isAllUnreadlSelected() {
    const numSelected = this.Unreadselection.selected.length;
    const numRows = this.unReadnotifs.length;
    return numSelected === numRows;
  }
  masterUnreadToggle() {
    this.isAllUnreadlSelected() ?
      this.Unreadselection.clear() :
      this.unReadnotifs.forEach(row => this.Unreadselection.select(row));
    this.isAllUnreadlSelected() ? this.unReadnotifs.forEach(row => row.checkbox = true) :
      this.unReadnotifs.forEach(row => row.checkbox = false);
  }


  isAllFlaggedlSelected() {
    const numSelected = this.Flaggedselection.selected.length;
    const numRows = this.flaggedNotifs.length;
    return numSelected === numRows;
  }
  masterFlaggedToggle() {
    this.isAllFlaggedlSelected() ?
      this.Flaggedselection.clear() :
      this.flaggedNotifs.forEach(row => this.Flaggedselection.select(row));
    this.isAllFlaggedlSelected() ? this.flaggedNotifs.forEach(row => row.checkbox = true) :
      this.flaggedNotifs.forEach(row => row.checkbox = false);
  }




  getNotification(data) {
   const NotifPage = data['PageType'];
    const apiData = {
      page: data.page
      , limit: data.pageSize
    };
    if (NotifPage === 'Delpage') {
      apiData['deleted_view'] = 'Y';
    }
    if (data['filter']) {
      apiData['filter'] = data['filter'];
    }
    this.spinner.show();
    this._api.functionPOST('user/getNofiticationAlertInboxForUser', apiData).subscribe((response) => {

      if (NotifPage === 'Delpage') {
        this.Delselection.clear();
        this.Deletednotifications = this._util.tableParser(response['data']['data']);
        this.Delpage.limit = response['data'].total;
      }
      if (NotifPage === 'NonDelpage') {
        this.selection.clear();
        this.notifications = this._util.tableParser(response['data']['data']);
        this.NonDelpage.limit = response['data'].total;
      }
      if (data['filter'] === 'unread') {
        this.Unreadselection.clear();
        this.unReadnotifs = this._util.tableParser(response['data']['data']);
        this.unread.limit = response['data'].total;
      }
      if (data['filter'] === 'flagged') {
        this.Flaggedselection.clear();
        this.flaggedNotifs = this._util.tableParser(response['data']['data']);
        this.flagged.limit = response['data'].total;
      }
      this.spinner.hide();
    });
  }
  getNotifDetails(data, index , type) {

    const dataIndex = ((this[type].index  + 1) - 1 ) * this[type].pageSize + index + 1;
    const popUpdata = { filter : type , index: dataIndex};
    if (type === 'NonDelpage' ) {
      popUpdata['filter'] = null;
    }

    this.openMessage(popUpdata);
  }

  deleteNotif(array , selection) {
     if (this[selection].selected.length === 0) {
      this._api.openSnackBar('Please Select Atleast One', 'Error');
      return;
    }
    const deleteNotif = [];
    this[array].map((x) => {
      if (x['checkbox']) {
        deleteNotif.push({
          record_id: x['nt_notification_alert_id']
        });
      }
    });
    const data = {
      items: deleteNotif

    };
    this._api.functionPOST('user/deleteNotificationsFromView', data).subscribe((response) => {
      this._api.openSnackBar(response.data, 'success');
      this.getNotis();

    });
  }
  openMessage(message) {
    const dialogRef = this.dialog.open( ViewMessageComponent ,{ data: message, minWidth: '80%', 
    height: '80vh', panelClass: 'custom-modalbox'});
    dialogRef.afterClosed().subscribe(result => {
      this.getNotis();
      this._util.ReadMessage(true);
    });

  }
  restoreNotif() {
    const deleteNotif = [];
    this.Deletednotifications.map((x) => {
      if (x['checkbox']) {
        deleteNotif.push({
          record_id: x['nt_notification_alert_id']
        });
      }
    });
    const data = {
      items: deleteNotif

    };
    this._api.functionPOST('user/restoreNotificationsToView', data).subscribe((response) => {
      this._api.openSnackBar(response.data, 'success');
      this.getNotis();
    });
  }
  changeFlagstats(status, data) {
    const apiData = {
      nt_notification_alert_id: data['nt_notification_alert_id'],
      action: status
    };
    this._api.functionPOST('user/flagNotification', apiData).subscribe((response) => {
   //   this.getNotification();
      this.getNotis();
    });

  }
  singleRead(data, action) {
    const apiData = {
      nt_notification_alert_ids: [data['nt_notification_alert_id']],
      action: action

    };
    this.readStatusAPI(apiData);

  }
  updateReadStats(action , array) {

    const notifIds = [];
    this[array].map((x) => {
      if (x['checkbox']) {
        notifIds.push(
          x['nt_notification_alert_id']
        );
      }
    });

    const data = {
      nt_notification_alert_ids: notifIds,
      action: action

    };

    this.readStatusAPI(data);

  }
  readStatusAPI(data) {
    this.spinner.show();
    this._api.functionPOST('user/updateNotificationStatus', data).subscribe((response) => {
      this.getNotis();
      this.spinner.hide();
      this._api.openSnackBar(response['data'], 'success');
    });
  }

}
